import React, { useState, useEffect, useCallback } from 'react'
import {
  Row,
  Col,
  Form,
  Select,
  Transfer,
  Tooltip,
  Button,
  Card,
  Tag,
} from 'antd'
import Input from '../../../ui/Input'
import TextArea from '../../../ui/TextArea'
import ActionButtonsBar from '../../../ui/ActionButtonsBar'
import Loading from '../../../Loading';
import { SearchOutlined } from '@ant-design/icons'
import {
  validateFormHelper,
  postHelper,
  putHelper,
  deleteHelper,
} from './helpers'
import { getOTACodes } from '../../../../services/common'
import { AmenitiesAPI, amenityType, guestroom } from './AmenitiesType'
import { isTagsDisplayed } from '@helpers/FeatureFlags'

const Option = Select.Option

type otaCode = {
  codeName: string
  codeType: string
  codeValue: string
  id: number
  key: string
  subCat: undefined | null | number | string | object
}

interface propsTypes {
  typeData: Array<{ codeName: string }>
  singleAmenity: amenityType
  mode: string
  isNewRecordRoom: boolean
  setDetailViewOn: (e: boolean) => void
  guestroom: guestroom
  setEditLoading: (e: boolean) => void
  update: (e: { amenities: amenityType[] }) => void
  localManagment: (e: amenityType, d: string) => void
  isOnEditMode: boolean
}
const AmenitiyDetail = (props: propsTypes) => {
  const [form] = Form.useForm()
  const [disableFlag, setDisableFlag] = useState<boolean>(false)
  const [isonEdit, setIsOnEdit] = useState<boolean>(false)
  const [requiredFlag] = useState(true)
  const [data, setData] = useState<Array<otaCode>>([])
  const [transferData, setTransferData] = useState<Array<otaCode>>([])
  const [transferTargetKeys, setTransferTargetKeys] = useState<Array<string>>(
    [],
  )
  const [selectedKeys, setSelectedKeys] = useState<Array<string>>([])
  const miscOptions = ['Amenity', 'Accessibility', 'Security']
  const unitOptions = [
    'Meters',
    'Millimeters',
    'Centimeters',
    'Yards',
    'Feet',
    'Inches',
    'Pixels',
  ]
  const [miscValue, setMiscValue] = useState<string>('')
  const [typeOptionsValues, setTypesOptionsValues] = useState([])
  const [currencyValues, setCurrencyValues] = useState([])
  const [showField, setShowField] = useState(false)
  const [ready, setReady] = useState(false)

  // validating the required values have been fufilled properly
  const validateForm = useCallback(() => {
    validateFormHelper(form, setDisableFlag)
  }, [form])

  const getCurrencyData = useCallback(async () => {
    let res = await getOTACodes('CUR', '')
    setCurrencyValues(res.otacodes)
  }, [])

  const setDefaultFormValues = useCallback(() => {
    // setting as defualt yes
    const includedinrateDefault =
      props.singleAmenity.includedinrate === undefined
        ? 'Yes'
        : props.singleAmenity.includedinrate
    form.setFieldsValue({
      id: props.singleAmenity.id,
      type: props.singleAmenity.type,
      details: props.singleAmenity.details,
      includedinrate: includedinrateDefault,
      quantity: props.singleAmenity.quantity,
      description: props.singleAmenity.description,
      tags: props.singleAmenity.tags,
      categorytype: props.singleAmenity.categorytype,
      unitofmeasure: props.singleAmenity.unitofmeasure,
      chargeamount: props.singleAmenity.chargeamount,
      currency: props.singleAmenity.currency,
    })
  }, [form, props.singleAmenity])

  // Init
  useEffect(() => {
    getTransferData()
    getCurrencyData()
    setDefaultFormValues()
    props.mode === 'Add' && setIsOnEdit(true)
    if (props.singleAmenity.type) {
      setShowField(true)
    }
    if (props.isOnEditMode) {
      setIsOnEdit(true)
    }
    setReady(true)
  }, [getCurrencyData, props.isOnEditMode, props.mode, props.singleAmenity.type, setDefaultFormValues])

  useEffect(() => {
    if (isonEdit) {
      const tags = new Array()
      props.singleAmenity.tags &&
        props.singleAmenity.tags
          .split('|')
          .filter((e: string) => e.length > 0)
          .forEach((item: string) => {
            const tag = transferData.find((tag: { codeName: string }) => {
              return tag.codeName === item.trim()
            })
            if (tag) {
              tags.push(`${tag.id}_${tag.codeName}`)
            }
          })

      setTransferTargetKeys(tags)
    }
  }, [isonEdit, props.singleAmenity.tags, transferData])

  const getTypesValues = useCallback(
    async (miscValue: string | null | undefined,isAmenitieChanging:boolean) => {
      let res = undefined
      switch (miscValue) {
        case 'Amenity':
          res = await getOTACodes('RMA', '')
          setTypesOptionsValues(res.otacodes)
          setShowField(true)
          break;
        case 'Accessibility':
          res = await getOTACodes('PHY', '')
          setTypesOptionsValues(res.otacodes)
          setShowField(true)
          break;
        case 'Security':
          res = await getOTACodes('SEC', '')
          setTypesOptionsValues(res.otacodes)
          setShowField(true)
          break;
        case 'Feature':
          setShowField(false)
          break;
        default:
          return setTypesOptionsValues([])
      }
      if(isAmenitieChanging) form.setFieldsValue({ type: null })

    },
    [form],
  )

  const changeAmenities = (miscValue:string,isAmenitieChanging:boolean) => {
      setMiscValue(miscValue)
      getTypesValues(miscValue,isAmenitieChanging)
  }

  useEffect(() => {
    getTypesValues(miscValue || props?.singleAmenity?.categorytype,false)
  }, [getTypesValues])

  useEffect(() => {
    if (isonEdit) {
      return validateForm()
    }
  }, [isonEdit, validateForm, showField])

  const getTransferData = async () => {
    let res = await getOTACodes('TAG', '')
    if (res && res.otacodes && res.otacodes.length !== 0) {
      res.otacodes.map(
        (item: { key: string; id: number; codeName: string }) =>
          (item.key = `${item.id}_${item.codeName}`),
      )
      setTransferData(res.otacodes)
      setData(res.otacodes)
    } else {
      setTransferData([])
    }
  }

  const onSearchChange = (e: { target: { value: string } }) => {
    let res = data.filter((item: { codeName: string }) => {
      return (
        item.codeName.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1
      )
    })
    setTransferData(res)
  }

  const getTagsToSed = () => {
    let tags = ''
    transferTargetKeys.forEach((item: string) => {
      tags = tags.concat(`${item.split('_')[1]} |`)
    })
    return tags
  }

  const cancel = () => {
    setReady(false)
    if (props.mode === 'Add') {
      props.setDetailViewOn(false)
    }
    if (props.mode === 'Edit') {
      setIsOnEdit(false)
      setDefaultFormValues()
      setReady(true)
      if (props.singleAmenity.categorytype === 'Feature') {
        return setShowField(false)
      }
      setShowField(true)
    }
  }

  const onChange = (
    nextTargetKeys: string[],
    direction: string,
    moveKeys: string[],
  ) => {
    disableFlag && setDisableFlag(false)
    setTransferTargetKeys(nextTargetKeys)
  }

  const onSelectChange = (
    sourceSelectedKeys: string[],
    targetSelectedKeys: string[],
  ) => {
    setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys])
  }

  const getBody = () => {
    const values = form.getFieldsValue(true)
    let body = {}
    if (props.mode === 'Add') {
      body = {
        guestroom: [
          {
            grid: props.guestroom.grid,
            grlangid: props.guestroom.grlangid,
            amenities: [
              {
                id: values.id,
                type: values.type,
                details: values.details,
                includedinrate: values.includedinrate,
                quantity: values.quantity,
                description: values.description,
                tags: getTagsToSed(),
                categorytype: values.categorytype,
                unitofmeasure: values.unitofmeasure,
                chargeamount: values.chargeamount,
                currency: values.currency,
              },
            ],
          },
        ],
      }
    }
    if (props.mode !== 'Add') {
      body = {
        guestroom: [
          {
            grid: props.guestroom.grid,
            grlangid: props.guestroom.grlangid,
            amenities: [
              {
                amenityid: props.singleAmenity.amenityid,
                amenitylangid: props.singleAmenity.amenitylangid,
                id: values.id,
                type: values.type,
                details: values.details,
                includedinrate: values.includedinrate,
                quantity: values.quantity,
                description: values.description,
                tags: getTagsToSed(),
                categorytype: values.categorytype,
                unitofmeasure: values.unitofmeasure,
                chargeamount: values.chargeamount,
                currency: values.currency,
              },
            ],
          },
        ],
      }
    }
    return body
  }

  const save = async () => {
    if (props.isNewRecordRoom) {
      return props.localManagment(
        {
          ...form.getFieldsValue(true),
          amenityid: props.singleAmenity.amenityid,
          amenitylangid: props.singleAmenity.amenitylangid,
          tags: getTagsToSed(),
        },
        props.mode,
      )
    }
    let response: AmenitiesAPI | null = null
    props.setEditLoading(true)
    try {
      const bodyShape = getBody()
      if (props.mode === 'Add') {
        response = await postHelper('/property/guestroom/amenities', bodyShape)
      }
      if (props.mode !== 'Add') {
        response = await putHelper('/property/guestroom/amenities', bodyShape)
      }
      // persisting the post data
      if (response && response.result.success && response.errors.length === 0) {
        let roomUpdated = response.property.guestrooms.guestroom.find(
          (item: { grid: number }) => item.grid === props.guestroom.grid,
        )
        setIsOnEdit(false)
        form.resetFields()
        props.setDetailViewOn(false)
        if (roomUpdated) {
          props.update(roomUpdated)
        }
      }
    } catch (error) {
      return error
    }
  }

  const erase = async () => {
    if (props.isNewRecordRoom) {
      return props.localManagment(
        {
          ...form.getFieldsValue(true),
          amenityid: props.singleAmenity.amenityid,
          amenitylangid: props.singleAmenity.amenitylangid,
          tags: getTagsToSed(),
        },
        'Delete',
      )
    }
    props.setEditLoading(true)
    try {
      const bodyShape = {
        guestroom: [
          {
            grid: props.guestroom.grid,
            grlangid: props.guestroom.grlangid,
            amenities: [
              {
                amenityid: props.singleAmenity.amenityid,
                amenitylangid: props.singleAmenity.amenitylangid,
              },
            ],
          },
        ],
      }
      const response: AmenitiesAPI = await deleteHelper(
        '/property/guestroom/amenities',
        bodyShape,
      )

      // persisting the post data
      if (response.result.success && response.errors.length === 0) {
        let roomUpdated = response.property.guestrooms.guestroom.find(
          (item: { grid: number }) => item.grid === props.guestroom.grid,
        )
        setIsOnEdit(false)
        form.resetFields()
        props.setDetailViewOn(false)
        if (roomUpdated) {
          props.update(roomUpdated)
        }
      }
    } catch (error) {
      return error
    }
  }

  if (!ready) return <Loading type={'large'} />
  return (
    <Card style={{ marginTop: -15, marginBottom: 65 }}>
      <div className='col-12'>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <span></span>
          {!isonEdit && (
            <>
              <div style={{ margin: '0 10px 0 0' }}>
                <Button
                  style={{
                    background: '#004771',
                    color: '#fff',
                    width: 60,
                    height: 28,
                  }}
                  onClick={() => props.setDetailViewOn(false)}>
                  Back
                </Button>
              </div>
              <div>
                <Button
                  style={{
                    background: '#004771',
                    color: '#fff',
                    width: 60,
                    height: 28,
                  }}
                  onClick={() => setIsOnEdit(true)}>
                  Edit
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
      <Form
        layout='vertical'
        form={form}
        name='basic'
        initialValues={{}}
        className={!isonEdit ? 'is-disabled-fields' : ''}
        onValuesChange={validateForm}>
        <Row gutter={24}>
          <Col span={7}>
            <Form.Item
              label='Amenity / Accessibility / Security'
              name='categorytype'
              rules={[
                {
                  required: requiredFlag,
                  message: 'This field is required',
                },
              ]}>
              <Select allowClear showSearch onChange={(e: string) => changeAmenities(e,true)}>
                {miscOptions.map((item: string, i: number) => (
                  <Option key={`${item}-${i}`} value={item}>
                    {item}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={7} className={showField ? '' : 'd-none'}>
            <Form.Item
              label='ID'
              name='id'>
               <Input />
            </Form.Item>
          </Col>
          <Col span={7} className={showField ? '' : 'd-none'}>
            <Form.Item
              label='Type'
              name='type'
              rules={
                showField
                  ? [
                      {
                        required: requiredFlag,
                        message: 'This field is required',
                      },
                    ]
                  : []
              }>
              <Select allowClear showSearch>
                {typeOptionsValues.map(
                  (item: { codeName: string }, i: number) => (
                    <Option key={`${item.codeName}-${i}`} value={item.codeName}>
                      {item.codeName}
                    </Option>
                  ),
                )}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={21}>
            <Form.Item
              label='Amenity Detail'
              name='details'
              extra={
                isonEdit ? (
                  <span className="blue-font">
                    Lanyon Maximum length:50. Please input exact time (24 hour
                    clock, - ex: 00:00-06:00 ) in Type Detail if choosing Type
                    as “If no 24 hour security, what are the hours?” for
                    Security. Please input minutes in Type Detail if choosing
                    Type as “Emergency svc response time (minutes).
                  </span>
                ) : null
              }
              rules={[
                {
                  max: 50,
                  message: 'You have reached the max character length of 50',
                },
              ]}>
              <Input maxLength={50} />
            </Form.Item>
          </Col>
        </Row>
        <br />
        <Row gutter={24}>
          <Col span={7}>
            <Form.Item
              label='Quantity'
              name='quantity'
              rules={[
                {
                  pattern: /^\+?\d+$/,
                  message: 'This field should be a number',
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item label='Unit of Measure' name='unitofmeasure'>
              <Select allowClear showSearch>
                {unitOptions.map((item: string, i: number) => (
                  <Option key={`${item}-${i}`} value={item}>
                    {item}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={21}>
            <Form.Item
              label='Description'
              name='description'
              rules={[
                {
                  max: 500,
                  message: 'You have reached the max character length of 500',
                },
              ]}>
              <TextArea maxLength={500} rows={3} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={7}>
            <Form.Item
              label='Included in Rate'
              name='includedinrate'
              rules={[
                {
                  required: requiredFlag,
                  message: 'This field is required',
                },
              ]}>
              <Select allowClear showSearch>
                <Option key={'yes-1'} value='Yes'>
                  Yes
                </Option>
                <Option key={'no-1'} value='No'>
                  No
                </Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item
              label='Charge Amount'
              name='chargeamount'
              rules={[
                {
                  pattern: /^[+]?[0-9]*\.?[0-9]*$/,
                  message: 'This field should be a number',
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item label='Currency' name='currency'>
              <Select allowClear showSearch>
                {currencyValues.map((item: { codeName: string }, i: number) => (
                  <Option key={`${item.codeName}-${i}`} value={item.codeName}>
                    {item.codeName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        { isTagsDisplayed &&
          <Row gutter={24}>
            {isonEdit ? (
              <Col span={12}>
                <Form.Item label='Selected Tags'>
                  <Input
                    onChange={onSearchChange}
                    style={{ width: '260px' }}
                    suffix={
                      <Tooltip title='search'>
                        <SearchOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                      </Tooltip>
                    }
                  />
                  <Transfer
                    dataSource={transferData}
                    targetKeys={transferTargetKeys}
                    selectedKeys={selectedKeys}
                    onChange={onChange}
                    onSelectChange={onSelectChange}
                    render={(item) => item.codeName}
                  />
                </Form.Item>
              </Col>
            ) : (
              <Col span={21} className='col-margin'>
                <div style={{ display: 'inline-block', width: '100%' }}>
                  <div
                    style={{
                      width: '100%',
                      fontSize: 12,
                      color: '#999999',
                      height: '24px',
                    }}>
                    Selected Tags
                  </div>
                  <div
                    style={{
                      width: '100%',
                      padding: '0 5px',
                      fontSize: '14px',
                      height: '35px',
                      marginTop: '5px',
                      lineHeight: '36px',
                    }}>
                    {props.singleAmenity.tags !== '' &&
                      props.singleAmenity.tags !== undefined &&
                      props.singleAmenity.tags !== null &&
                      props.singleAmenity.tags
                        .split('|')
                        .map((item: string, index: number) => {
                          if (item.length > 0)
                            return <Tag key={index}>{item}</Tag>
                          return <></>
                        })}
                  </div>
                </div>
              </Col>
            )}
          </Row>
        }
      </Form>
      <div className="roomType-edit_amenities">
        <ActionButtonsBar
          onDelete={props.mode === 'Edit' && erase}
          onCancel={cancel}
          onSave={save}
          disabledSave={disableFlag}
          show={isonEdit}
        />
      </div>
    </Card>
  )
}

export default AmenitiyDetail
